import React from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse
} from '@mui/material';
import {
  CheckCircle as CheckIcon,
  RadioButtonUnchecked as UncheckedIcon
} from '@mui/icons-material';

const PasswordValidation = ({ 
  requirements = {}, 
  requirementsText = [], 
  show = false,
  errors = []
}) => {
  if (!show || requirementsText.length === 0) {
    return null;
  }

  return (
    <Collapse in={show}>
      <Box sx={{ mt: 1, mb: 2 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Password requirements:
        </Typography>
        <List dense sx={{ py: 0 }}>
          {requirementsText.map((requirement, index) => {
            // Map requirement text to requirement keys
            const requirementKey = getRequirementKey(requirement);
            const isMet = requirements[requirementKey] === true;
            
            return (
              <ListItem key={index} sx={{ py: 0.25, px: 0 }}>
                <ListItemIcon sx={{ minWidth: 32 }}>
                  {isMet ? (
                    <CheckIcon 
                      sx={{ 
                        fontSize: 16, 
                        color: 'success.main' 
                      }} 
                    />
                  ) : (
                    <UncheckedIcon 
                      sx={{ 
                        fontSize: 16, 
                        color: 'text.disabled' 
                      }} 
                    />
                  )}
                </ListItemIcon>
                <ListItemText 
                  primary={requirement}
                  primaryTypographyProps={{
                    variant: 'body2',
                    sx: {
                      color: isMet ? 'success.main' : 'text.secondary',
                      fontWeight: isMet ? 500 : 400
                    }
                  }}
                />
              </ListItem>
            );
          })}
        </List>
        
        {errors.length > 0 && (
          <Box sx={{ mt: 1 }}>
            {errors.map((error, index) => (
              <Typography 
                key={index}
                variant="body2" 
                color="error" 
                sx={{ fontSize: '0.75rem' }}
              >
                {error}
              </Typography>
            ))}
          </Box>
        )}
      </Box>
    </Collapse>
  );
};

// Helper function to map requirement text to requirement keys
const getRequirementKey = (requirementText) => {
  if (requirementText.includes('characters')) return 'min_length';
  if (requirementText.includes('uppercase')) return 'uppercase';
  if (requirementText.includes('lowercase')) return 'lowercase';
  if (requirementText.includes('number')) return 'numbers';
  if (requirementText.includes('special')) return 'special';
  return 'unknown';
};

export default PasswordValidation;
